import { render } from "./MenuBase.vue?vue&type=template&id=10994bc5&scoped=true&ts=true"
import script from "./MenuBase.vue?vue&type=script&lang=ts"
export * from "./MenuBase.vue?vue&type=script&lang=ts"

import "./MenuBase.vue?vue&type=style&index=0&id=10994bc5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10994bc5"]])

export default __exports__